import { combineReducers } from 'redux';
import ads from './ads/reducer';
import app from './app/reducer';
import auth from './auth/reducer';
import author from './author/reducer';
import blog from './blog/reducer';
import charts from './charts/reducer';
import comments from './comments/reducer';
import dashboard from './dashboard/reducer';
import forum from './forum/reducer';
import music from './music/reducer';
import mailbox from './mailbox/reducer';
import playlists from './playlists/reducer';
import search from './search/reducer';
import subscriptions from './subscriptions/reducer';
import player from './player/reducer';
import users from './users/reducer';

export default combineReducers({
  ads,
  app,
  auth,
  author,
  blog,
  charts,
  comments,
  dashboard,
  forum,
  mailbox,
  music,
  playlists,
  search,
  subscriptions,
  player,
  users,
});
